import React, { useEffect } from 'react';
import {
    message,
    Button,
    Icon,
    Modal,
    Form,
    Input,
    Radio,
    Card,
    Select,
    Table,
    Checkbox,
    Row,
    Col,
    DatePicker,
    Tag,
    Popconfirm,
    Spin,
} from 'antd';
import { services } from '@comall-backend-builder/core';

import './index.less';
import { errorHandle } from '../../services';
import ExportExcel from './exportExcel';
import moment from 'moment';
import { render } from 'react-dom';
const { Search } = Input;
const { confirm } = Modal;

const { RangePicker } = DatePicker;
const api = services.api;

export interface ExtendLabelRuleAddViewProps {
    form: any;
}
const confirmProps = {
    title: '确定要删除吗？',
    okText: '确定',
    cancelText: '取消',
};
// 商品经营管理
const ExtendLabelRuleAddView = ({ form }: ExtendLabelRuleAddViewProps) => {
    const path = services.navigation.getPathname();
    const [isEdit, setIsEdit] = React.useState(!path.includes('detail'));
    const [isEditEffectivePeriod, setIsEditEffectivePeriod] = React.useState(false);
    const [updateForm, setUpdateForm] = React.useState({});
    const [labelList, setLabelList] = React.useState([]);
    // 设置方式的值
    const [setWay, setSetWay] = React.useState('PRODUCT');
    // 选择商品码表的字段
    const [step, setStep] = React.useState(1);
    const [modalStatus, setModalStatus] = React.useState('ADD');
    const [radioValue, setRadioValue] = React.useState(null);
    const [selectedRadio, setSelectedRadio] = React.useState([]);
    const [attributeOptions, setAttributeOptions] = React.useState([]);
    const [attributeData, setAttributeData] = React.useState([]);
    const [categoryCodeOptions, setCategoryCodeOptions] = React.useState([]);
    const [categoryData, setCategoryData] = React.useState([]);
    const [categorySelectedData, setCategorySelectedData] = React.useState([]);
    const [visible, setVisible] = React.useState(false);
    // 商品码表的数据
    const [tableData, setTableData] = React.useState([]);
    // 导入华夏款号的弹窗
    const [exportVisible, setExportVisible] = React.useState(false);
    const [styleTableData, setStyleTableData] = React.useState([]);
    const [styleSelectedkeys, setStyleSelectedkeys] = React.useState([]);
    // 导入SKU编码的弹窗
    const [exportSkuVisible, setSkuExportVisible] = React.useState(false);
    const [skuTableData, setSkuTableData] = React.useState([]);
    const [skuSelectedkeys, setSkuSelectedkeys] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [deleteLoading, setDeleteLoading] = React.useState(false);
    const [submitError, setSubmitError] = React.useState(false);
    const handleChangeTable = (value: any, record) => {
        const data = tableData.map((item) => {
            if (item.code === record.code) {
                return { ...item, attribute_value_name: value };
            }
            return item;
        });
        setTableData(data);
    };
    const skuColumns = [
        {
            title: 'sku编码',
            dataIndex: 'uniqueCode',
            key: 'uniqueCode',
            align: 'center' as const,
        },
        {
            title: 'sku名称',
            dataIndex: 'goodsName',
            key: 'goodsName',
            align: 'center' as const,
        },
        {
            title: '货品品类',
            dataIndex: 'categoryName',
            key: 'categoryName',
            align: 'center' as const,
        },
        {
            title: '是否上架',
            dataIndex: 'salesStatus',
            key: 'salesStatus',
            align: 'center' as const,
            render: (text, record) => (record.salesStatus === 'NOT_SALES' ? '下架' : '上架'),
        },
        {
            title: '可用库存',
            dataIndex: 'stock',
            key: 'stock',
            align: 'center' as const,
        },
        {
            title: '操作',
            align: 'center' as const,
            render: (_, record) => [
                <Popconfirm
                    {...confirmProps}
                    onConfirm={() =>
                        setSkuTableData(
                            skuTableData.filter((item) => item.uniqueCode !== record.uniqueCode)
                        )
                    }
                >
                    <a className="table-action-column-item">删除</a>
                </Popconfirm>,
            ],
        },
    ];
    const styleColumns = [
        {
            title: '华夏款号',
            dataIndex: 'styleCode',
            key: 'styleCode',
            align: 'center' as const,
        },
        {
            title: '货品品类',
            dataIndex: 'categoryName',
            key: 'categoryName',
            align: 'center' as const,
        },
        {
            title: '操作',
            align: 'center' as const,
            render: (_, record) => [
                <Popconfirm
                    {...confirmProps}
                    onConfirm={() =>
                        setStyleTableData(
                            styleTableData.filter((item) => item.styleCode !== record.styleCode)
                        )
                    }
                >
                    <a className="table-action-column-item">删除</a>
                </Popconfirm>,
            ],
        },
    ];
    const columns = [
        {
            title: '属性编码',
            dataIndex: 'code',
            key: 'code',
            align: 'center' as const,
        },
        {
            title: '字典编码',
            dataIndex: 'sapCode',
            key: 'sapCode',
            align: 'center' as const,
            render: (text: string) => (text ? text : '-'),
        },
        {
            title: '属性名称',
            dataIndex: 'name',
            key: 'name',
            align: 'center' as const,
        },
        {
            title: '属性类型',
            dataIndex: 'type',
            key: 'type',
            render: (text: string) => {
                return text === 'OPTION' || text === 'KEY_VALUE' ? '码表' : '文本';
            },
            align: 'center' as const,
        },
        {
            title: '属性值/文本',
            dataIndex: 'attribute_value_name',
            key: 'attribute_value_name',
            render: (text: any, record: any) => {
                if (!isEdit) {
                    if (record.type === 'VARCHAR' || record.type === 'TEXT') {
                        return text;
                    } else {
                        return text.join(',');
                    }
                } else {
                    if (record.type === 'VARCHAR' || record.type === 'TEXT') {
                        return (
                            <Input
                                value={text}
                                key={record.code}
                                onChange={(e) => {
                                    handleChangeTable(e.target.value, record);
                                }}
                            />
                        );
                    } else {
                        return text.join(',');
                    }
                }
            },
            align: 'center' as const,
        },
        {
            title: '操作',
            align: 'center' as const,
            render: (_, record) => [
                record.type === 'OPTION' && isEdit && (
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            getCategoryCodeOptions(record.code);
                            setRadioValue(record.id);
                            setSelectedRadio([record]);
                            setCategorySelectedData(
                                record.attribute_value_name.map((item, index) => ({
                                    code: record.attribute_value_code[index],
                                    label: item,
                                }))
                            );
                            setStep(2);
                            setModalStatus('UPDATE');
                            setVisible(true);
                        }}
                    >
                        设置码表值
                    </Button>
                ),
                isEdit && (
                    <Popconfirm
                        {...confirmProps}
                        onConfirm={() =>
                            setTableData(tableData.filter((item) => item.code !== record.code))
                        }
                    >
                        <Button size="small" type="link">
                            删除
                        </Button>
                    </Popconfirm>
                ),
            ],
        },
    ];

    const handleCancel = () => {
        setVisible(false);
        setStep(1);
        setModalStatus('ADD');
        setRadioValue(null);
        setSelectedRadio([]);
        setAttributeData(attributeOptions);
        setCategoryCodeOptions([]);
        setCategoryData([]);
        setCategorySelectedData([]);
        setSkuExportVisible(false);
        setExportVisible(false);
    };

    const getCategoryCodeOptions = (code: string) => {
        api.get({ attr_code: code, page: 1, per_page: 9999 }, { apiPath: '/attributes/options' })
            .then((res: any) => {
                if (res && res.result) {
                    setCategoryCodeOptions(
                        res.result.map((item: any) => ({
                            code: item.optionCode,
                            label: item.optionName,
                        }))
                    );
                    setCategoryData(
                        res.result.map((item: any) => ({
                            code: item.optionCode,
                            label: item.optionName,
                        }))
                    );
                }
            })
            .catch(errorHandle);
    };
    const getAttributeOptions = () => {
        api.get({ page: 1, per_page: 9999 }, { apiPath: '/products/getAttrList' })
            .then((res: any) => {
                if (res && res.result) {
                    setAttributeOptions(res.result);
                    setAttributeData(res.result);
                }
            })
            .catch(errorHandle);
    };
    const onSave = () => {
        form.validateFields((err, values) => {
            if (!err) {
                if (labelList.length === 0) {
                    setSubmitError(true);
                    return;
                } else {
                    setSubmitError(false);
                }
                const params = {
                    ...values,
                    processStatus: 0,
                    effectiveStatus: 0,
                    brandCode: 860,
                };
                if (values.configurationType == 1) {
                    params.start_effective_time = moment(values.labelStatus[0]).format(
                        'YYYY-MM-DDTHH:mm:ss.SSSZ'
                    );
                    params.end_effective_time = moment(values.labelStatus[1]).format(
                        'YYYY-MM-DDTHH:mm:ss.SSSZ'
                    );
                }
                delete params.labelStatus;
                params.tagRuleItemList = labelList;
                if (setWay === 'PRODUCT') {
                    if (tableData.length === 0) {
                        message.error('请置少配置一条完整属性');
                        return;
                    }
                    const noText = tableData.find(
                        (item) =>
                            !item.attribute_value_name || item.attribute_value_name.length === 0
                    );
                    if (noText) {
                        message.error('属性名称文本值不能为空');
                        return;
                    }
                    params.tagRuleAttributeList = tableData.map((item, index) => ({
                        attribute_key_code: item.code,
                        attribute_value_code:
                            item.type === 'VARCHAR' || item.type === 'TEXT'
                                ? item.attribute_value_name
                                : item.attribute_value_code.join(','),
                        sort: index,
                    }));
                } else if (setWay === 'SKU') {
                    params.tagRuleSettingList = skuTableData.map((item) => ({
                        unique_code: item.uniqueCode,
                    }));
                } else if (setWay === 'STYLE') {
                    params.tagRuleSettingList = styleTableData.map((item) => ({
                        unique_code: item.styleCode,
                    }));
                }
                setLoading(true);
                if (path.includes('update')) {
                    api.post({ ...updateForm, ...params }, { apiPath: '/searchTag/tagRuleUpdate' })
                        .then((res: any) => {
                            setLoading(false);
                            if (res && res.resultCode === 200) {
                                message.success('保存成功');
                                window.history.back();
                            } else {
                                message.error(res.resultMsg);
                            }
                        })
                        .catch(errorHandle);
                } else {
                    api.post(params, { apiPath: '/searchTag/tagRuleAdd' })
                        .then((res: any) => {
                            setLoading(false);
                            if (res && res.resultCode === 200) {
                                message.success('保存成功');
                                window.history.back();
                            } else {
                                message.error(res.resultMsg);
                            }
                        })
                        .catch(errorHandle);
                }
            }
        });
    };
    const initForm = async () => {
        if (path.includes('update') || path.includes('detail')) {
            const id = path.split('/').pop();
            const { resultBody, resultCode } = await api.get(
                { page: 1, per_page: 10 },
                { apiPath: `/searchTag/tagRuleDetail/${id}` }
            );
            if (resultCode === 200) {
                const data = resultBody;
                setUpdateForm(data);
                setLabelList(data.tagRuleItemList);
                if (data.configurationType === 1) {
                    setIsEditEffectivePeriod(true);
                }
                form.setFieldsValue({
                    tagRuleName: data.tagRuleName,
                    configurationType: data.configurationType,
                    labelStatus:
                        data.configurationType === 1
                            ? [moment(data.startEffectiveTime), moment(data.endEffectiveTime)]
                            : undefined,
                    settingWay: data.settingWay,
                });
                setSetWay(data.settingWay);
                if (data.settingWay === 'PRODUCT') {
                    setTableData(
                        data.tagRuleAttributeList.map((item) => ({
                            code: item.attributeKeyCode,
                            sapCode: item.dictKeyCode,
                            name: item.attributeKeyName,
                            type: item.attributeType === 'key_value' ? 'OPTION' : 'TEXT',
                            attribute_value_code:
                                item.attributeType === 'key_value'
                                    ? item.attributeValueCode.split(',')
                                    : item.attributeValueCode,
                            attribute_value_name:
                                item.attributeType === 'key_value'
                                    ? item.attributeValueDesc.split(',')
                                    : item.attributeValueDesc,
                        }))
                    );
                } else if (data.settingWay === 'SKU') {
                    const res: any = await api.get(
                        { tagRuleCode: id, page: 1, per_page: 1000 },
                        { apiPath: `/searchTag/tagPageSettings` }
                    );
                    setSkuTableData(res.result);
                } else if (data.settingWay === 'STYLE') {
                    const res: any = await api.get(
                        { tagRuleCode: id, page: 1, per_page: 1000 },
                        { apiPath: `/searchTag/tagPageSettings` }
                    );
                    setStyleTableData(
                        res.result.map((item) => ({ ...item, styleCode: item.uniqueCode }))
                    );
                }
            }
        } else {
            form.setFieldsValue({
                configurationType: 0,
                settingWay: 'PRODUCT',
            });
        }
    };
    const handleChangeEffectivePeriod = (e) => {
        if (e.target.value === 0) {
            form.setFieldsValue({
                labelStatus: [null, null],
            });
            setIsEditEffectivePeriod(false);
        } else {
            setIsEditEffectivePeriod(true);
        }
    };
    const handleChangeSettingWay = (e) => {
        setSetWay(e.target.value);
    };
    useEffect(() => {
        getAttributeOptions();
        initForm();
    }, []);
    const cardTitle = (
        <>
            <span>设置扩展标签</span>
            <span style={{ fontSize: '12px', color: '#1890FF' }}>
                (适用场景,自定义风格,场景,功能,用户UGC标签)
            </span>
        </>
    );
    const checkboxLabel = (data) => (
        <div style={{ display: 'inline-block' }}>
            <div style={{ display: 'inline-block', width: '100px' }}>{data.code}</div>
            <div style={{ display: 'inline-block' }}>{data.label}</div>
        </div>
    );
    const radioLabel = (data) => (
        <div style={{ display: 'inline-block' }}>
            <div style={{ display: 'inline-block', width: '100px' }}>{data.code}</div>
            <div style={{ display: 'inline-block' }}>{data.name}</div>
        </div>
    );
    const handleAddLabel = () => {
        const newLabel = form.getFieldValue('tagRuleItem');
        if (
            newLabel === undefined ||
            newLabel.trim() === '' ||
            newLabel.trim().length > 20 ||
            labelList.find((item) => item.tagName === newLabel.trim())
        ) {
            message.error('请输入正确的标签名称');
            return;
        }
        setSubmitError(false);
        setLabelList([...labelList, { sort: labelList.length + 1, tagName: newLabel }]);
        form.setFieldsValue({
            tagRuleItem: '',
        });
    };
    const handleCancelLabel = (e, data) => {
        if (data.tagRuleCode) {
            e.preventDefault();
            setDeleteLoading(true);
            api.get({}, { apiPath: `/searchTag/tagBoolean/${data.tagName}` })
                .then((res: any) => {
                    if (res.resultCode === 200 && !res.resultBody) {
                        const labels = labelList.filter((item) => item.sort !== data.sort);
                        setLabelList(labels);
                    } else {
                        confirm({
                            title: '提示',
                            content: '已有商品使用此标签, 请确认是否删除',
                            onOk() {
                                const labels = labelList.filter((item) => item.sort !== data.sort);
                                setLabelList(labels);
                            },
                            onCancel() {},
                        });
                    }
                    setDeleteLoading(false);
                })
                .catch(() => {
                    setDeleteLoading(false);
                });
            return false;
        } else {
            const labels = labelList.filter((item) => item.sort !== data.sort);
            setLabelList(labels);
        }
    };
    const saveData = (data) => {
        setStyleTableData(data);
        handleCancel();
    };
    const saveSkuData = (data) => {
        setSkuTableData(data);
        handleCancel();
    };
    const skuRowSelection = {
        onChange: (selectedRowKeys) => {
            setSkuSelectedkeys(selectedRowKeys);
        },
    };
    const styleRowSelection = {
        onChange: (selectedRowKeys) => {
            setStyleSelectedkeys(selectedRowKeys);
        },
    };
    return (
        <>
            <Card title={cardTitle}>
                <Form layout="inline">
                    <Row>
                        <Form.Item label="规则名称">
                            {form.getFieldDecorator('tagRuleName', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入规则名称',
                                    },
                                    {
                                        max: 50,
                                        message: '规则名称长度不能超过50个字符',
                                    },
                                    {
                                        validator: (rule, value, callback) => {
                                            if (value && value.trim() === '') {
                                                callback('规则名称不能为空格');
                                            } else {
                                                callback();
                                            }
                                        },
                                    },
                                ],
                            })(
                                <Input
                                    placeholder="请输入规则名称"
                                    disabled={!isEdit}
                                    style={{ width: 250 }}
                                />
                            )}
                        </Form.Item>
                    </Row>
                    <Row>
                        <Form.Item label="标签名称" required={true}>
                            <Spin spinning={deleteLoading}>
                                {labelList.map((d) => (
                                    <Tag
                                        key={d.sort}
                                        closable={isEdit}
                                        data-item={d}
                                        onClose={(e) => handleCancelLabel(e, d)}
                                    >
                                        {d.tagName}
                                    </Tag>
                                ))}
                            </Spin>
                            {form.getFieldDecorator('tagRuleItem', {
                                rules: [
                                    {
                                        validator: (rule, value, callback) => {
                                            const data = labelList.find(
                                                (item) => item.tagName === value
                                            );
                                            if (data) {
                                                callback('不能与已有标签重复');
                                            } else {
                                                callback();
                                            }
                                        },
                                    },
                                    {
                                        max: 20,
                                        message: '标签名称长度不能超过20个字符',
                                    },
                                    {
                                        pattern: /^[^!@#$%^&*]+$/,
                                        message: '标签名称不能包含特殊字符 !@#$%^&*',
                                    },
                                ],
                            })(
                                <Input
                                    placeholder="请输入标签名称"
                                    disabled={!isEdit}
                                    style={{ width: 250 }}
                                />
                            )}
                            {isEdit && (
                                <Button
                                    type="primary"
                                    style={{ marginLeft: 8, marginBottom: 18 }}
                                    onClick={handleAddLabel}
                                >
                                    新增标签
                                </Button>
                            )}
                            {submitError && (
                                <div style={{ color: 'red', lineHeight: '25px' }}>请新增标签</div>
                            )}
                        </Form.Item>
                    </Row>
                    <Row>
                        <Col lg={10} xl={8} xxl={6}>
                            <Form.Item label="有效期">
                                {form.getFieldDecorator('configurationType', {
                                    rules: [
                                        {
                                            required: true,
                                            message: '请选择有效期',
                                        },
                                    ],
                                })(
                                    <Radio.Group
                                        disabled={!isEdit}
                                        onChange={handleChangeEffectivePeriod}
                                    >
                                        <Radio value={0}>永不失效</Radio>
                                        <Radio value={1}>按配置生效</Radio>
                                    </Radio.Group>
                                )}
                            </Form.Item>
                        </Col>
                        {isEditEffectivePeriod && (
                            <Col xl={12} xxl={12}>
                                <Form.Item>
                                    {form.getFieldDecorator('labelStatus', {
                                        rules: [
                                            {
                                                required: true,
                                                message: '请选择时间范围',
                                            },
                                        ],
                                    })(
                                        <RangePicker
                                            disabled={!isEdit}
                                            showTime
                                            placeholder={['开始时间', '结束时间']}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        )}
                    </Row>
                    <Row>
                        <Form.Item label="设置方式">
                            {form.getFieldDecorator('settingWay', {
                                rules: [
                                    {
                                        required: true,
                                        message: '请选择设置方式',
                                    },
                                ],
                            })(
                                <Radio.Group disabled={!isEdit} onChange={handleChangeSettingWay}>
                                    <Radio value="PRODUCT">按商品参数配置</Radio>
                                    <Radio value="SKU">按SKU配置</Radio>
                                    <Radio value="STYLE">按华夏款号配置</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>
                    </Row>
                </Form>
            </Card>
            <Card title="设置规则范围" style={{ marginTop: 20 }}>
                {setWay === 'PRODUCT' && (
                    <>
                        <Table
                            columns={path.includes('detail') ? columns.slice(0, -1) : columns}
                            dataSource={tableData}
                            key="code"
                        />
                        {isEdit ? (
                            <div
                                style={{
                                    textAlign: 'center',
                                    width: '100%',
                                    padding: '5px 0px',
                                    border: '1px solid #ccc',
                                    marginTop: 20,
                                    cursor: 'pointer',
                                }}
                                onClick={() => {
                                    setModalStatus('ADD');
                                    setVisible(true);
                                }}
                            >
                                <Icon type="plus-circle" />
                                添加商品属性
                            </div>
                        ) : null}
                    </>
                )}
                {setWay === 'SKU' && (
                    <>
                        {isEdit && (
                            <div>
                                <Button
                                    type="primary"
                                    style={{ marginRight: 8, marginBottom: 18 }}
                                    onClick={() => {
                                        setSkuExportVisible(true);
                                    }}
                                >
                                    导入数据
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        setSkuTableData(
                                            skuTableData.filter(
                                                (item) => !skuSelectedkeys.includes(item.uniqueCode)
                                            )
                                        );
                                    }}
                                >
                                    批量删除
                                </Button>
                            </div>
                        )}
                        <Table
                            rowKey="uniqueCode"
                            rowSelection={skuRowSelection}
                            columns={path.includes('detail') ? skuColumns.slice(0, -1) : skuColumns}
                            dataSource={skuTableData}
                        />
                    </>
                )}
                {setWay === 'STYLE' && (
                    <>
                        {isEdit && (
                            <div>
                                <Button
                                    type="primary"
                                    style={{ marginRight: 8, marginBottom: 18 }}
                                    onClick={() => {
                                        setExportVisible(true);
                                    }}
                                >
                                    导入数据
                                </Button>
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        console.log(
                                            styleSelectedkeys,
                                            'styleSelectedkeys',
                                            styleTableData
                                        );
                                        setStyleTableData(
                                            styleTableData.filter(
                                                (item) =>
                                                    !styleSelectedkeys.includes(item.styleCode)
                                            )
                                        );
                                    }}
                                >
                                    批量删除
                                </Button>
                            </div>
                        )}
                        <Table
                            rowKey="styleCode"
                            rowSelection={styleRowSelection}
                            columns={
                                path.includes('detail') ? styleColumns.slice(0, -1) : styleColumns
                            }
                            dataSource={styleTableData}
                        />
                    </>
                )}

                <Modal
                    destroyOnClose
                    visible={visible}
                    title="选择商品属性"
                    onCancel={handleCancel}
                    footer={[
                        step === 1 && selectedRadio[0] && selectedRadio[0]?.type === 'OPTION' && (
                            <Button
                                type="primary"
                                onClick={() => {
                                    setStep(2);
                                    getCategoryCodeOptions(selectedRadio[0].code);
                                }}
                            >
                                下一步
                            </Button>
                        ),

                        step === 2 &&
                            selectedRadio[0] &&
                            selectedRadio[0]?.type === 'OPTION' &&
                            modalStatus !== 'UPDATE' && (
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        setStep(1);
                                    }}
                                >
                                    上一步
                                </Button>
                            ),

                        ((step === 1 && selectedRadio[0] && selectedRadio[0]?.type === 'VARCHAR') ||
                            (step === 2 &&
                                selectedRadio[0] &&
                                selectedRadio[0]?.type === 'OPTION')) && (
                            <Button
                                style={{ marginLeft: 10 }}
                                onClick={() => {
                                    if (modalStatus === 'ADD') {
                                        if (
                                            tableData.find(
                                                (item) => item.id === selectedRadio[0]?.id
                                            )
                                        ) {
                                            message.error('该字段已存在');
                                            return;
                                        }
                                        setTableData((prevData) => {
                                            const newData = [
                                                ...prevData,
                                                {
                                                    ...selectedRadio[0],
                                                    attribute_value_code: categorySelectedData.map(
                                                        (item) => item.code
                                                    ),
                                                    attribute_value_name: categorySelectedData.map(
                                                        (item) => item.label
                                                    ),
                                                },
                                            ];
                                            return newData;
                                        });
                                    } else if (modalStatus === 'UPDATE') {
                                        setTableData((prevData) => {
                                            const newData = prevData;
                                            newData.forEach((item) => {
                                                if (item.code === selectedRadio[0].code) {
                                                    item.attribute_value_name = categorySelectedData.map(
                                                        (item) => item.label
                                                    );
                                                    item.attribute_value_code = categorySelectedData.map(
                                                        (item) => item.code
                                                    );
                                                }
                                            });
                                            return newData;
                                        });
                                    }
                                    handleCancel();
                                }}
                            >
                                确认
                            </Button>
                        ),

                        <Button style={{ marginLeft: 10 }} onClick={handleCancel}>
                            取消
                        </Button>,
                    ]}
                    width={900}
                    style={{ paddingBottom: 120 }}
                >
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div
                            style={{
                                width: '50%',
                                borderRight: '1px solid #eee',
                                height: '400px',
                                padding: '10px',
                                overflowY: 'auto',
                            }}
                        >
                            {step === 1 ? (
                                <>
                                    <Search
                                        placeholder="输入码表编号或码表名称"
                                        onSearch={(value) =>
                                            setAttributeData(
                                                attributeOptions.filter(
                                                    (item: any) =>
                                                        item.name.includes(value) ||
                                                        item.code.includes(value)
                                                )
                                            )
                                        }
                                        onBlur={(e) =>
                                            setAttributeData(
                                                attributeOptions.filter(
                                                    (item: any) =>
                                                        item.name.includes(e.target.value) ||
                                                        item.code.includes(e.target.value)
                                                )
                                            )
                                        }
                                        style={{ width: '100%' }}
                                    />
                                    <div style={{ padding: '10px 0px' }}>
                                        <Icon type="database" /> 商品主数据码表
                                    </div>
                                    <Radio.Group
                                        style={{ width: '100%' }}
                                        value={radioValue}
                                        onChange={(e) => {
                                            setRadioValue(e.target.value);
                                            setSelectedRadio(
                                                attributeOptions.filter(
                                                    (item) => item.id === e.target.value
                                                )
                                            );
                                        }}
                                    >
                                        {attributeData.map((item: any, index: number) => (
                                            <Row key={index}>
                                                <Radio
                                                    style={{ width: '100%' }}
                                                    key={item.id}
                                                    value={item.id}
                                                >
                                                    {radioLabel(item)}
                                                </Radio>
                                            </Row>
                                        ))}
                                    </Radio.Group>
                                </>
                            ) : (
                                <>
                                    <Search
                                        placeholder="输入码表编号或码表名称"
                                        onSearch={(value) =>
                                            setCategoryData(
                                                categoryCodeOptions.filter(
                                                    (item: any) =>
                                                        item.name.includes(value) ||
                                                        item.code.includes(value)
                                                )
                                            )
                                        }
                                        onBlur={(e) =>
                                            setCategoryData(
                                                categoryCodeOptions.filter(
                                                    (item: any) =>
                                                        item.name.includes(e.target.value) ||
                                                        item.code.includes(e.target.value)
                                                )
                                            )
                                        }
                                        style={{ width: '100%' }}
                                    />
                                    <div style={{ padding: '10px 0px' }}>
                                        <Icon type="database" /> 商品主数据码表
                                    </div>
                                    <Checkbox.Group
                                        style={{ width: '100%' }}
                                        value={categorySelectedData.map((item) => item.code)}
                                        onChange={(checkedValues) => {
                                            const allChecked = categorySelectedData.map(
                                                (item) => item.code
                                            );
                                            const notInSelect = allChecked.filter(
                                                (code) =>
                                                    !categoryData
                                                        .map((item) => item.code)
                                                        .includes(code)
                                            );
                                            const uniqueCodes = new Set([
                                                ...notInSelect,
                                                ...checkedValues,
                                            ]);
                                            setCategorySelectedData(
                                                Array.from(uniqueCodes).map((code) => {
                                                    const existingItem = categorySelectedData.find(
                                                        (item) => item.code === code
                                                    );
                                                    if (existingItem) {
                                                        return existingItem;
                                                    } else {
                                                        return categoryCodeOptions.find(
                                                            (item) => item.code === code
                                                        );
                                                    }
                                                })
                                            );
                                        }}
                                    >
                                        {categoryData.map((item: any) => (
                                            <Row>
                                                <Checkbox
                                                    style={{ width: '100%' }}
                                                    key={item.code}
                                                    value={item.code}
                                                >
                                                    {checkboxLabel(item)}
                                                </Checkbox>
                                            </Row>
                                        ))}
                                    </Checkbox.Group>
                                </>
                            )}
                        </div>
                        <div
                            style={{
                                width: '50%',
                                padding: '10px',
                                height: '400px',
                                overflowY: 'auto',
                            }}
                        >
                            {step === 1 ? (
                                <>
                                    <div
                                        style={{
                                            padding: '10px 0px',
                                            display: 'flex',
                                            width: '100%',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div>
                                            <Icon type="check-circle" /> 已选
                                            {`${selectedRadio.length}/1`}
                                        </div>
                                        <Button
                                            type="link"
                                            onClick={() => {
                                                setSelectedRadio([]);
                                                setRadioValue(null);
                                            }}
                                        >
                                            清空
                                        </Button>
                                    </div>
                                    {selectedRadio.map((item: any) => (
                                        <div
                                            key={item.id}
                                            style={{
                                                padding: '0px 10px',
                                                border: '1px solid rgb(242, 241, 240)',
                                                lineHeight: '30px',
                                                background: 'rgb(242, 241, 240)',
                                                borderRadius: '20px',
                                                marginBottom: '5px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <span style={{ marginRight: '10px' }}>{item.name}</span>
                                            <Icon
                                                type="close"
                                                style={{ lineHeight: '30px', color: '#1890FF' }}
                                                onClick={() => {
                                                    setSelectedRadio([]);
                                                    setRadioValue(null);
                                                }}
                                            />
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <>
                                    <div
                                        style={{
                                            padding: '10px 0px',
                                            display: 'flex',
                                            width: '100%',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div>
                                            <Icon type="check-circle" /> 已选
                                            {`${categorySelectedData.length}/${attributeOptions.length}`}
                                        </div>

                                        <Button
                                            type="link"
                                            onClick={() => {
                                                setCategorySelectedData([]);
                                            }}
                                        >
                                            清空
                                        </Button>
                                    </div>
                                    {categorySelectedData.map((item: any) => (
                                        <div
                                            key={item.id}
                                            style={{
                                                padding: '0px 10px',
                                                border: '1px solid rgb(242, 241, 240)',
                                                lineHeight: '30px',
                                                background: 'rgb(242, 241, 240)',
                                                borderRadius: '20px',
                                                marginBottom: '5px',
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <span style={{ marginRight: '10px' }}>
                                                {item.label}
                                            </span>
                                            <Icon
                                                type="close"
                                                style={{ lineHeight: '30px', color: '#1890FF' }}
                                                onClick={() => {
                                                    setCategorySelectedData(
                                                        categorySelectedData.filter(
                                                            (attr) => attr.code !== item.code
                                                        )
                                                    );
                                                }}
                                            />
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>
                    </div>
                </Modal>
                <Modal
                    visible={exportVisible}
                    title="数据导入"
                    onCancel={handleCancel}
                    width={900}
                    zIndex={1}
                    footer={null}
                    destroyOnClose
                    style={{ paddingBottom: 120 }}
                >
                    <ExportExcel
                        url="/searchTag/get/styleCategoryInfo"
                        limitSize={10}
                        ExcelHead={{
                            sheet: {
                                华夏款号: 'unique_code',
                            },
                        }}
                        templateDown="TAG_RULE_STYLE"
                        custColumns={styleColumns.slice(0, -1)}
                        saveData={saveData}
                        handleCancel={handleCancel}
                    />
                </Modal>
                <Modal
                    visible={exportSkuVisible}
                    title="数据导入"
                    destroyOnClose
                    onCancel={handleCancel}
                    width={900}
                    zIndex={1}
                    footer={null}
                    style={{ paddingBottom: 120 }}
                >
                    <ExportExcel
                        url="/searchTag/skuInfos"
                        limitSize={10}
                        custColumns={skuColumns.slice(0, -1)}
                        ExcelHead={{
                            sheet: {
                                SKU编号: 'unique_code',
                            },
                        }}
                        templateDown="TAG_RULE_SKU"
                        saveData={saveSkuData}
                        handleCancel={handleCancel}
                    />
                </Modal>
                {isEdit ? (
                    <div>
                        <Button
                            type="primary"
                            style={{ marginTop: 20 }}
                            loading={loading}
                            onClick={onSave}
                        >
                            保存
                        </Button>
                        <Button
                            style={{ marginLeft: 10, marginTop: 20 }}
                            onClick={() => {
                                window.history.back();
                            }}
                        >
                            取消
                        </Button>
                    </div>
                ) : (
                    <Button
                        style={{ marginLeft: 10, marginTop: 20 }}
                        onClick={() => {
                            window.history.back();
                        }}
                    >
                        返回
                    </Button>
                )}
            </Card>
        </>
    );
};

export const extendLabelRuleAddView = Form.create()(ExtendLabelRuleAddView);
